import { SvgIcon, SvgIconProps } from '@mui/material';
import { IconTypes as SolidIconTypes } from './generated/regular';
import { IconTypes as DuotoneIconTypes } from './generated/duotone';
import { IconTypes as CustomIconTypes } from './generated/custom';
import * as RegularIcons from './generated/regular';
import * as DuotoneIcons from './generated/duotone';
import * as CustomIcons from './generated/custom';

export type IconTypes = SolidIconTypes | DuotoneIconTypes | CustomIconTypes;
export interface IconPropTypes extends SvgIconProps {
  icon: SolidIconTypes | DuotoneIconTypes | CustomIconTypes;
  styleType?: 'regular' | 'duotone' | 'custom';
}

export const Icon = (props: IconPropTypes) => {
  const { icon, styleType = 'regular', ...rest } = props;
  const GeneratedIcon =
    styleType === 'duotone'
      ? DuotoneIcons[icon]
      : styleType === 'custom'
      ? CustomIcons[icon]
      : RegularIcons[icon];

  return (
    <SvgIcon inheritViewBox {...rest}>
      <GeneratedIcon />
    </SvgIcon>
  );
};
